import React, { useState } from "react";
import { Label, Tooltip } from "reactstrap";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import styles from "./style.module.scss";
import cx from "classnames";
import TooltipIcon from "components/TooltipIcon";

const InputLabel = (props) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { className, description, isCheckboxInput = false, id, tag } = props;
  const tooltipId = `${id}_tooltip`;
  const LabelTag = tag ? tag : Label;

  const toggle = () => {
    setTooltipOpen(!tooltipOpen);
  }

  return (
    <>
      {props.children && (
        <LabelTag className={cx({
          [className]: className,
          [styles.label]: description
        })}
          check={isCheckboxInput}
          for={id}>
          {props.children}
          {description && (
            <>
              <TooltipIcon>
                {description}
              </TooltipIcon>
            </>
          )}
        </LabelTag>
      )}
    </>
  );
}

export default InputLabel;